import { Link } from "react-router-dom";

const jurisdictions = [
  "Pennsylvania",
  "New York",
  "New Jersey",
  "Delaware",
  "Maryland",
  "Virginia",
  "Ohio",
  "California",
  "Texas",
  "Florida",
  "Illinois",
  "Massachusetts",
  "All 50 States (Federal)",
];

const nearbyAreas = [
  { city: "Philadelphia, PA", type: "Main Office" },
  { city: "Pittsburgh, PA", type: "Service Area" },
  { city: "New York, NY", type: "Service Area" },
  { city: "Newark, NJ", type: "Service Area" },
  { city: "Baltimore, MD", type: "Service Area" },
  { city: "Washington, DC", type: "Service Area" },
];

export default function SectionServiceAreas() {
  return (
    <section className="bg-[#F8F7F4] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <span className="block text-[11px] tracking-[0.25em] text-[#C9A961] uppercase font-inter font-medium mb-3">
            Where We Practice
          </span>
          <h2 className="text-4xl lg:text-5xl font-playfair font-bold text-[#0A1628] mb-4">
            Service Areas &amp; Jurisdiction
          </h2>
          <p className="text-slate-600 font-inter text-base max-w-2xl mx-auto">
            Based in Philadelphia, our firm advises clients throughout the United States on federal health law matters.
            For state-specific issues, we coordinate with trusted local counsel nationwide.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 items-start">
          {/* Map — spans 3 cols */}
          <div className="lg:col-span-3">
            <div className="rounded-xl overflow-hidden border border-slate-200 relative" style={{ height: "460px" }}>
              <iframe
                title="Alice G. Gosfield &amp; Associates Office Location — Philadelphia, PA"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.234580!2d-75.1762!3d39.9425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6c62b8e2b3a5f%3A0x0!2s2309+Delancey+Pl%2C+Philadelphia%2C+PA+19103!5e0!3m2!1sen!2sus!4v1640000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="flex items-center gap-4 mt-4">
              <div className="flex items-start gap-2 text-sm font-inter text-slate-600">
                <i className="ri-map-pin-2-line text-[#C9A961] mt-0.5 flex-shrink-0" />
                <span>2309 Delancey Pl., Philadelphia, PA 19103</span>
              </div>
              <span className="text-slate-300">|</span>
              <a
                href="tel:+12157352384"
                className="flex items-center gap-1.5 text-sm font-inter text-slate-600 hover:text-[#0A1628] transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-[#C9A961]" />
                (215) 735-2384
              </a>
            </div>
          </div>

          {/* Right info — spans 2 cols */}
          <div className="lg:col-span-2 flex flex-col gap-7">
            {/* Jurisdictions */}
            <div>
              <h3 className="text-sm font-inter font-semibold text-[#0A1628] uppercase tracking-wider mb-4">
                States &amp; Jurisdictions Served
              </h3>
              <div className="flex flex-wrap gap-2">
                {jurisdictions.map((j) => (
                  <span
                    key={j}
                    className="px-3 py-1.5 rounded-full bg-white border border-slate-200 text-xs font-inter text-[#0A1628] font-medium"
                  >
                    {j}
                  </span>
                ))}
              </div>
            </div>

            {/* Major cities */}
            <div>
              <h3 className="text-sm font-inter font-semibold text-[#0A1628] uppercase tracking-wider mb-4">
                Key Service Locations
              </h3>
              <div className="flex flex-col gap-2">
                {nearbyAreas.map((area) => (
                  <div
                    key={area.city}
                    className="flex items-center justify-between py-2.5 px-4 bg-white rounded-lg border border-slate-100"
                  >
                    <div className="flex items-center gap-2">
                      <i className="ri-map-pin-line text-[#C9A961] text-sm" />
                      <span className="text-sm font-inter text-[#0A1628]">{area.city}</span>
                    </div>
                    <span className={`text-xs font-inter px-2 py-0.5 rounded-full ${
                      area.type === "Main Office"
                        ? "bg-[#C9A961]/15 text-[#8B6914] font-medium"
                        : "bg-slate-100 text-slate-500"
                    }`}>
                      {area.type}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <Link
              to="/locations/philadelphia"
              className="inline-flex items-center gap-2 text-sm font-inter font-semibold text-[#C9A961] hover:text-[#b8954f] transition-colors cursor-pointer whitespace-nowrap"
            >
              View Full Location Details
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
